import { SCHOOL_LIST, GUEST_MODAL, SCHOOL_INFO } from "../actions/types";

const initialState = {
   schoolList: [],
   schoolInfo: {},
   guestModal: true
}

export default function (state = initialState, action) {

   const { type, payload } = action;

   switch (type) {
      case SCHOOL_LIST:
         return { ...state, schoolList: payload }
      case SCHOOL_INFO:
         return { ...state, schoolInfo: payload }
      case GUEST_MODAL:
         return { ...state, guestModal: payload }
      default:
         return state;
   }
}